<app-webpage-analytics></app-webpage-analytics>

<app-progress-spinner [color]="color" [mode]="mode" [value]="value" [backdropEnabled]="true"
	[positionGloballyCenter]="true" [displayProgressSpinner]="displayProgressSpinner"></app-progress-spinner>

<div [formGroup]="f" class="flex">
    <div class="searchContainer ontario-row">
 
        <div class="mt-2 ontario-form-group">
            <fieldset class="ontario-fieldset">
                <!-- Search Results-->
                <legend class="ontario-fieldset__legend ontario-fieldset__legend--large remove-legend-cursor-pointer">
                    {{ 'search.geologyontario.title' | translate | async }}
                </legend>

                <app-breadcrumbs></app-breadcrumbs>


                <!-- Search Buttons Row-->
                <div>
                    <mat-form-field appearance="outline" class="search-input-form">
                        <input matInput trim="blur" class="search-input" formControlName="searchValue"
                            id="search-box" maxlength="300" (keyup.enter)="search()" (keyup)="completionSuggest($event)"
                            attr.aria-label="{{ 'search.input' | translate | async }}" />

                        <button *ngIf="f.get('searchValue').value" matSuffix mat-icon-button class="clear-input-button" 
                            attr.aria-label="{{ 'search.clear' | translate | async }}" (click)="onClearPressed()">
                            <mat-icon>close</mat-icon>
                        </button>

                        <button matSuffix class="search-input-button" attr.aria-label="{{ 'search.button' | translate | async }}" 
                            (click)="search()" [disabled]="!databaseIsSelected">
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
            </fieldset>
            
            <div *ngIf="this.autoCompleteSuggestions.length > 0" class="suggestionsArea">
                <button *ngFor="let suggestion of this.autoCompleteSuggestions" class="suggestions" tabindex="0" (click)="correctionSuggestionSelected(suggestion.text)">
                    {{ suggestion.text }}
                </button>
            </div>
        </div>

        <div *ngIf="displayPagination" id="searchResultsTotal"
            class="ontario-callout ontario-border-highlight--teal">
            <h2 class="ontario-callout__title ontario-h5">
                <ng-container *ngIf="this.totalResults > 0; else noRecords">
                    {{ startIndex + 1 }} - {{ endIndex }} {{ 'of' | translate | async }} {{ this.totalResults }} {{ 'results.for' | translate | async }} "{{ searchInput }}"

                    <p></p>
                    <p class="doubleClickCallout">
                        {{ 'double.clicking.opens.new.tab' | translate | async }}
                    </p>
                </ng-container>
                <ng-template #noRecords>
                    {{ this.totalResults }} {{ 'results.for' | translate | async }} "{{ searchInput }}"
                </ng-template>
            </h2>
            <div *ngIf="this.corrections.length > 0">
                <p class="ontario-callout__title ontario-h6">{{ 'search.instead.for' | translate |async }}</p>
                <div class="correctionsArea">
                    <div *ngFor="let correction of this.corrections">
                        <a class="mr-2" (click)="correctionSuggestionSelected(correction.text)">
                            {{ correction.text }}
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="searchResultsContainer">
            <div class="searchFilters">
                <!-- Search Within Filter -->
                <app-result-type-filter [f]="f" (enableFilter)="toggleSearchFilters($event)"></app-result-type-filter>

                <fieldset>
                    <legend class="ontario-fieldset__legend ontario-fieldset__legend--large remove-legend-cursor-pointer">
                        {{ 'filters' | translate | async }}
                    </legend>

                    <!-- Database Filter -->
                    <app-database-filter [f]="f" [clearFilter]="clearFilter" (databaseIsSelected)="updateDatabaseBoolean($event)"></app-database-filter>

                    <!-- Township Filter -->
                    <app-township-filter [f]="f" [clearFilter]="clearFilter" [enableFilter]="enableFilter"></app-township-filter>

                    <!-- NTS Filter -->
                    <app-nts-filter [f]="f" [clearFilter]="clearFilter" [enableFilter]="enableFilter"></app-nts-filter>

                    <!-- Year Filter -->
                    <app-year-filter [f]="f" [clearFilter]="clearFilter" [enableFilter]="enableFilter"></app-year-filter>
                    
                    <!-- Commodity Filter -->
                    <app-commodity-filter [f]="f" [clearFilter]="clearFilter" [enableFilter]="enableFilter"></app-commodity-filter>

                    <!-- Author Filter -->
                    <app-author-filter [f]="f" [clearFilter]="clearFilter" [enableFilter]="enableFilter"></app-author-filter>

                    <!-- Series Filter -->
                    <app-series-filter [f]="f" [clearFilter]="clearFilter" [enableFilter]="enableFilter"></app-series-filter>

                    <!-- Filter Butons -->
                    <div class="flex-child">
                        <button type="button" attr.aria-label="{{ 'apply.filters' | translate | async }}"
                            class="ontario-button w-100 ontario-button--primary" 
                            [ngClass]="!enableFilter ? 'primaryButtonDisabled' : ''"
                            (click)="search()" [disabled]="!enableFilter" [tabIndex]="0">
                            {{ 'apply.filters' | translate | async }}
                        </button>
    
                        <button type="button" attr.aria-label="{{ 'clear.filters' | translate | async }}"
                            class="ontario-button w-100 ontario-button--secondary" 
                            [ngClass]="!enableFilter ? 'secondaryButtonDisabled' : ''"
                            (click)="onClearFiltersPressed()" [disabled]="!enableFilter" [tabIndex]="0">
                            {{ 'clear.filters' | translate | async }}
                        </button>
                    </div>

                </fieldset>
            </div>

            <div class="flex-child searchResults">
                <app-search-results-table [dataSource]="results" [searchTerm]="this.searchValue.value" [searchPressed]="searchPressed" [displayProgressSpinner]="displayProgressSpinner"></app-search-results-table>

                <!-- Pagination -->
                <div *ngIf="this.totalResults > 0" class="flex">
                    <button type="button" attr.aria-label="{{ 'apply.filters' | translate | async }}"
                        class="ontario-button ontario-button--primary exportButton" 
                        (click)="exportToExcel()" [tabIndex]="0">
                        {{ 'export.to.excel' | translate | async }}
                    </button>

                    <mat-paginator attr.aria-label="{{ 'page.navigation' | translate | async }}" [length]="this.totalResults"
                        [pageSize]="this.resultsPerPage" [pageSizeOptions]="[5,10,25,50]" [showFirstLastButtons]="true" [pageIndex]="this.pageIndex"
                        (page)="onPageChange($event)" class="paginator">
                    </mat-paginator>
                </div>
            </div>
        </div>

        <!-- Scroll Button -->
        <button onClick="scrollToTop()" class="ontario-back-to-top--default">
            <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                <use href="#ontario-icon-arrow-up"></use>
            </svg>
            {{ 'top' | translate | async }}
        </button>

    </div>
</div>